/* pulse-dance-tiles.js
 *
 * Behaviour for the dance style tiles (snippets/pulse-dance-tile.liquid), shared by the
 * homepage "Danced in, everywhere" grid and the rail at the foot of every dance-style
 * collection (2026-09-14). Was an inline script in sections/pulse-folders.liquid; it
 * moved here unchanged so the second surface does not carry a copy.
 *
 * Every [data-pulse-danced-in] root gets, independently:
 *   - PLAY OPENS THE SHARED VIEWER. The root's [data-pdi-clips] JSON lists every clip in
 *     tile order; a play button opens window.PulseVideoViewer at the first clip whose
 *     "tile" equals the button's data-index, and the visitor pages on through the rest.
 *   - CLIPS PLAY ONLY WHILE HALF ON SCREEN. A <video> ships with no src (audit T-20); it
 *     gets one the first time it is seen, pauses when it leaves, and nothing plays at all
 *     under prefers-reduced-motion, where the poster is the whole tile.
 *   - PREVIOUS / NEXT, only where the root has them ([data-pdi-track], [data-pdi-prev],
 *     [data-pdi-next]). They page the track by most of a view and are DISABLED rather
 *     than hidden at either end, so the row never changes width. The homepage grid has
 *     none, so this part does nothing there.
 */
(function () {
  if (window.PulseDanceTiles) return;

  function boot(root) {
    if (!root || root.getAttribute('data-pdi-bound')) return;
    root.setAttribute('data-pdi-bound', '1');

    var items = [];
    var tag = root.querySelector('[data-pdi-clips]');
    if (tag) {
      try { items = JSON.parse(tag.textContent) || []; } catch (e) { items = []; }
    }

    /* the first clip belonging to a tile, by the index the button carries */
    function firstOfTile(tile) {
      for (var i = 0; i < items.length; i++) {
        if (items[i] && items[i].tile === tile) return i;
      }
      return -1;
    }

    var clips = [].slice.call(root.querySelectorAll('[data-pdi-clip]'));

    [].slice.call(root.querySelectorAll('[data-pdi-play]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* the viewer script is deferred: before it lands a click simply does nothing */
        var viewer = window.PulseVideoViewer;
        if (!viewer || !viewer.open || !items.length) return;
        var at = firstOfTile(parseInt(btn.getAttribute('data-index'), 10));
        if (at < 0) return;
        /* stop every tile clip decoding behind the dialog; the close listener below
           re-triggers the IntersectionObserver to resume whichever are still in view */
        clips.forEach(function (v) { if (!v.paused) v.pause(); });
        viewer.open(items, at);
      });
    });

    var track = root.querySelector('[data-pdi-track]');
    if (track) {
      var prev = root.querySelector('[data-pdi-prev]');
      var next = root.querySelector('[data-pdi-next]');
      var sync = function () {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      };
      var page = function (dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.getAttribute('src')) {
            var src = v.getAttribute('data-src');
            if (!src) return;
            v.setAttribute('src', src);
          }
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.5 });

    clips.forEach(function (v) {
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      io.observe(v);
    });

    /* the viewer's close() dispatches this; re-observing forces the callback above to
       re-run against the current viewport and resume whatever is still in view */
    document.addEventListener('pulse:video-viewer-close', function () {
      clips.forEach(function (v) { io.unobserve(v); io.observe(v); });
    });
  }

  function bootAll(scope) {
    var s = scope || document;
    if (s.matches && s.matches('[data-pulse-danced-in]')) boot(s);
    [].slice.call(s.querySelectorAll('[data-pulse-danced-in]')).forEach(boot);
  }

  window.PulseDanceTiles = { boot: boot, bootAll: bootAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }

  /* the theme editor re-renders a section without reloading the page */
  document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
})();
